import { render, staticRenderFns } from "./DppOfferRowComponent.vue?vue&type=template&id=72cb065e&scoped=true&"
import script from "./DppOfferRowComponent.vue?vue&type=script&lang=js&"
export * from "./DppOfferRowComponent.vue?vue&type=script&lang=js&"
import style0 from "./DppOfferRowComponent.vue?vue&type=style&index=0&id=72cb065e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72cb065e",
  null
  
)

export default component.exports